import React, { Component } from "react";

// Business Steps
import Step1Business from "./BusinessForm/Step1Business";
import Step2Services from "./BusinessForm/Step2Services";
import Step3Website from "./BusinessForm/Step3Website";
import Step4Mobile from "./BusinessForm/Step4Mobile";
import Step5Marketing from "./BusinessForm/Step5Marketing";
import Step6Software from "./BusinessForm/Step6Software";
import Step7Requirement from "./BusinessForm/Step7Requirement";
import Step8Review from "./BusinessForm/Step8Review";

// Student Steps
import Step1Student from "./StudentForm/Step1Student";
import Step2Domain from "./StudentForm/Step2Domain";
import Step3Technology from "./StudentForm/Step3Technology";
import Step4Duration from "./StudentForm/Step4Duration";
import Step5Package from "./StudentForm/Step5Package";
import Step6Project from "./StudentForm/Step6Project";
import Step7Review from "./StudentForm/Step7Review";

class GetCosting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userType: "",
      step: 0,
      formData: {},
      businessSteps: [],
      successMessage: "",
      loading: false, // NEW
    };
  }

  // ===========================
  // Select User Type
  // ===========================
  selectUser = (type) => {
    this.setState({
      userType: type,
      step: 1,
      businessSteps: [],
      formData: {},
      successMessage: "",
    });
  };

  // ===========================
  // Next Step
  // ===========================
  nextStep = () => {
    this.setState((prev) => ({
      step: prev.step + 1,
    }));
  };

  // ===========================
  // Previous Step
  // ===========================
  prevStep = () => {
    this.setState((prev) => ({
      step: prev.step - 1,
    }));
  };

  // ===========================
  // Save Form Data
  // ===========================
  updateFormData = (data) => {
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        ...data,
      },
    }));
  };

  // ===========================
  // Reset Form After Success
  // ===========================
  resetForm = (message = "") => {
    this.setState(
      {
        userType: "",
        step: 0,
        formData: {},
        businessSteps: [],
        successMessage: message,
      },
      () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // use "auto" if you don't want animation
        });
      }
    );
  };

  // ===========================
  // Build Business Flow
  // ===========================
  buildBusinessSteps = (services) => {
    let flow = ["business", "services"];

    if (services.includes("Website Development")) {
      flow.push("website");
    }

    if (services.includes("Mobile App Development")) {
      flow.push("mobile");
    }

    if (services.includes("Digital Marketing")) {
      flow.push("marketing");
    }

    if (services.includes("Software Development")) {
      flow.push("software");
    }

    flow.push("requirement");
    flow.push("review");

    this.setState({
      businessSteps: flow,
    });
  };

  // ===========================
  // Business Flow
  // ===========================
  renderBusinessSteps = () => {
    const props = {
      nextStep: this.nextStep,
      prevStep: this.prevStep,
      updateFormData: this.updateFormData,
      buildBusinessSteps: this.buildBusinessSteps,
      resetForm: this.resetForm, // NEW
      formData: this.state.formData,
    };

    const flow =
      this.state.businessSteps.length > 0
        ? this.state.businessSteps
        : ["business", "services"];

    const current = flow[this.state.step - 1];

    switch (current) {
      case "business":
        return <Step1Business {...props} />;

      case "services":
        return <Step2Services {...props} />;

      case "website":
        return <Step3Website {...props} />;

      case "mobile":
        return <Step4Mobile {...props} />;

      case "marketing":
        return <Step5Marketing {...props} />;

      case "software":
        return <Step6Software {...props} />;

      case "requirement":
        return <Step7Requirement {...props} />;

      case "review":
        return <Step8Review {...props} />;

      default:
        return null;
    }
  };

  // ===========================
  // Student Flow
  // ===========================
  renderStudentSteps = () => {
    const props = {
      nextStep: this.nextStep,
      prevStep: this.prevStep,
      updateFormData: this.updateFormData,
      resetForm: this.resetForm,   // <-- ADD THIS
      formData: this.state.formData,
    };

    switch (this.state.step) {
      case 1:
        return <Step1Student {...props} />;

      case 2:
        return <Step2Domain {...props} />;

      case 3:
        return <Step3Technology {...props} />;

      case 4:
        return <Step4Duration {...props} />;

      case 5:
        return <Step5Package {...props} />;

      case 6:
        return <Step6Project {...props} />;

      case 7:
        return <Step7Review {...props} />;

      default:
        return null;
    }
  };

    render() {
    const { userType, step, successMessage } = this.state;

    // ===========================
    // Home Screen
    // ===========================
    if (step === 0) {
      return (
        <>
          <section className="py-3">
            <div className="container">

              {successMessage && (
                <div
                  className="alert alert-success alert-dismissible fade show"
                  role="alert"
                >
                  <strong>Success!</strong> {successMessage}

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() =>
                      this.setState({
                        successMessage: "",
                      })
                    }
                  ></button>
                </div>
              )}

            </div>
          </section>
          <section className="bg-primary text-white py-5">
            <div className="container text-center">
              <h1 className="display-5 fw-bold">Get Costing</h1>
              <p className="lead">
                Select your requirement to continue.
              </p>
            </div>
          </section>

          <section className="py-5">
            <div className="container">
              <div className="row justify-content-center">

                {/* Business */}

                <div className="col-lg-5 mb-4">
                  <div className="card shadow border-0 h-100">

                    <div className="card-body text-center p-5">

                      <div className="display-3 mb-3">
                        🏢
                      </div>

                      <h3 className="fw-bold">
                        Business
                      </h3>

                      <p className="text-muted">
                        Get quotation for Website Development,
                        Mobile App Development,
                        Software Development and
                        Digital Marketing.
                      </p>

                      <button
                        className="btn btn-primary btn-lg"
                        onClick={() => this.selectUser("business")}
                      >
                        Continue as Business
                      </button>

                    </div>

                  </div>
                </div>

                {/* Student */}

                <div className="col-lg-5 mb-4">
                  <div className="card shadow border-0 h-100">

                    <div className="card-body text-center p-5">

                      <div className="display-3 mb-3">
                        🎓
                      </div>

                      <h3 className="fw-bold">
                        Student
                      </h3>

                      <p className="text-muted">
                        Get Internship Costing,
                        Project Guidance,
                        Certificate,
                        Experience Letter and
                        Ready-made Project.
                      </p>

                      <button
                        className="btn btn-success btn-lg"
                        onClick={() => this.selectUser("student")}
                      >
                        Continue as Student
                      </button>

                    </div>

                  </div>
                </div>

              </div>
            </div>
          </section>
        </>
      );
    }

    return (
      <>
        <section className="bg-light py-4">

          <div className="container">

            <button
              className="btn btn-outline-secondary mb-4"
              onClick={() =>
                this.setState({
                  userType: "",
                  step: 0,
                  formData: {},
                  businessSteps: [],
                  successMessage: "",
                })
              }
            >
              ← Back to Selection
            </button>

            {/* Success Message */}

            {this.state.successMessage && (
              <div className="alert alert-success alert-dismissible fade show mb-4">
                <strong>Success!</strong> {this.state.successMessage}

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.setState({ successMessage: "" })}
                ></button>
              </div>
            )}

            {/* Progress */}

            <div className="mb-4">

              <div className="d-flex justify-content-between mb-2">

                <strong>
                  Step {step}
                </strong>

                <strong>
                  {userType === "business"
                    ? `${step} / ${this.state.businessSteps.length || 2}`
                    : `${step} / 7`}
                </strong>

              </div>

              <div className="progress">

                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  style={{
                    width:
                      userType === "business"
                        ? `${(step / (this.state.businessSteps.length || 2)) * 100}%`
                        : `${(step / 7) * 100}%`,
                  }}
                ></div>

              </div>

            </div>

            {/* Render Forms */}

            {userType === "business"
              ? this.renderBusinessSteps()
              : this.renderStudentSteps()}

          </div>

        </section>
      </>
    );
  }
}

export default GetCosting;